import { Directive } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, AsyncValidatorFn } from '@angular/forms';

export function uniqueEmailValidator(service): AsyncValidatorFn {
  return (control: AbstractControl): Promise<{[key: string]: any}>  => {
    return new Promise((resolve) => {
      if (control.value === '') { return resolve(null); }

      service.isUnique(control.value)
        .subscribe(({ isUnique }: { isUnique: boolean }) => {
          return resolve(!!isUnique ? null : { existingEmail: true });
        });
    });
  };
}

@Directive({
  selector: '[appUniqueEmail]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: UniqueEmailValidatorDirective, multi: true }],
})
export class UniqueEmailValidatorDirective {
}
